/**
 * Visuals Engine General
 */
export const VisualEngineConfig = {
  clearColor: '#000000',
  fpsTarget: 60,
  smoothing: false,
};

export default VisualEngineConfig;
